import { IconProps } from "./types";

export default function IcoArrowDown({
	color = "#FFF",
	width = "11",
	height = "14"
}: IconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 11 14"
			fill="none"
		>
			<g clipPath="url(#clip0_650_2260)">
				<path
					d="M4.63213 12.868C4.97393 13.2098 5.529 13.2098 5.8708 12.868L10.2458 8.49297C10.5876 8.15117 10.5876 7.59609 10.2458 7.2543C9.90401 6.9125 9.34893 6.9125 9.00713 7.2543L6.1251 10.1391V1.75C6.1251 1.26602 5.73408 0.875 5.2501 0.875C4.76611 0.875 4.3751 1.26602 4.3751 1.75V10.1363L1.49307 7.25703C1.15127 6.91523 0.596191 6.91523 0.254395 7.25703C-0.0874024 7.59883 -0.0874024 8.15391 0.254395 8.4957L4.6294 12.8707L4.63213 12.868Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id="clip0_650_2260">
					<path d="M0 0H10.5V14H0V0Z" fill={color} />
				</clipPath>
			</defs>
		</svg>
	);
}
